@if (question) {
    <div>
        <h3>{{ question.question }}</h3>
        <form [formGroup]="form" (ngSubmit)="save()">
            <mat-radio-group formControlName="choice_id">
                @for (choice of question.choices; track choice) {
                    <div>
                        <mat-radio-button [value]="choice.id">{{ choice.text }}</mat-radio-button>
                    </div>
                }
            </mat-radio-group>
            <button [disabled]="isSaving || form.invalid" mat-raised-button color="primary" type="submit">
                Opslaan
            </button>
        </form>
    </div>
}
@if (!question) {
    <div>
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
}
